import styled from 'styled-components'
import { COLORS } from '@themes'

type BadgeStyleProps = {
  $isActive: boolean
}

type SelectedStyleProps = {
  $isSelected: boolean
}

export const StatusBadgeStyle = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
`

export const Badge = styled.div<BadgeStyleProps>`
  padding: 2px 4px 2px 8px;
  background: ${({ $isActive }) => ($isActive ? COLORS.BLUE_1 : COLORS.GRAY_2)};
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;

  .label {
    color: ${COLORS.WHITE_1};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
  }

  .chevron {
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &::after {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      border-right: 1.5px solid ${COLORS.WHITE_1};
      border-bottom: 1.5px solid ${COLORS.WHITE_1};
      transform: rotate(45deg) translateY(-1px);
    }
  }
`

export const StyledMenuBox = styled.div`
  margin-top: 4px;
  padding: 2px;
  background: var(--popover-popover, #15151e);
  box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1), 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  outline: 1px var(--form-border, #292a3d) solid;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: inline-flex;
`

export const StyledMenuItem = styled.div<SelectedStyleProps>`
  width: 120px;
  padding: 8px;
  background: ${({ $isSelected }) => ($isSelected ? 'var(--popover-popover, #15151E)' : 'transparent')};
  overflow: hidden;
  border-radius: 6px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  cursor: pointer;

  &:hover {
    background: var(--popover-popover, #15151e);
  }
`

export const StyledMenuItemLabel = styled.span<SelectedStyleProps>`
  color: ${({ $isSelected }) =>
    $isSelected ? 'var(--primary-primary, #3B8FFD)' : 'var(--popover-popover-foreground, #E8EAF6)'};
  font-size: 16px;
  font-family: Sarabun;
  font-weight: 500;
  line-height: 24px;
  word-wrap: break-word;
`

export const StyledRightdecoration = styled.div`
  width: 20px;
  padding: 2px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: inline-flex;
`

export const StyledCheckIcon = styled.img`
  width: 16px;
  height: 16px;
  display: block;
`
